<!-- 公共头部 -->
<template>
  <div class="header_wrap">
    <div class="logo_wrap">
      <div class="w flex_b logo">
        <router-link class="logo_l flex" :to="{ name: 'upload' }" tag="div">
          <img src="../assets/imgs/logo1.png" alt="" class="logo_img" />
          <h1>
            <img src="../assets/imgs/logo.png" alt="" class="logo_txt" />
            <p>Eastrans Multi-Lingual Translation Services</p>
          </h1>
        </router-link>
        <div class="login_r flex" v-if="path_txt !=='/arxiv' && path_txt !=='/previewArxiv'">
          <router-link
            v-show="disable !== true"
            :to="{ name: 'conversion' }"
            class="white"
            :class="active == '1' ? 'active' : ''"
            tag="div"
            >格式转换</router-link
          >
          <router-link
            v-show="disable !== true"
            :to="{ name: 'upload' }"
            class="white"
            :class="active == '2' ? 'active' : ''"
            tag="div"
            >文档翻译</router-link
          >

          <router-link
            v-show="disable !== true"
            :to="{ name: 'index' }"
            class="white"
            :class="active == '3' ? 'active' : ''"
            tag="div"
            >文本翻译</router-link
          >
          <router-link
            v-show="disable !== true"
            :to="{ name: 'history' }"
            class="white"
            :class="active == '4' ? 'active' : ''"
            tag="div"
            >翻译历史</router-link
          >
          <span v-show="disable == true" class="white">格式转换</span>
          <span v-show="disable == true" class="white">文档翻译</span>
          <span v-show="disable == true" class="white">文本翻译</span>
          <span v-show="disable == true" class="white">翻译历史</span>
          <span v-show="disable == true" class="iconfont" style="color: #fff"
            >欢迎 {{ userinfo.username
            }}<i class="iconfont icon-yonghu-fuben"></i
          ></span>
          <!-- <router-link :to="{name:'about'}" class="white about" :class="active=='4'?'active':''" tag="div">关于我们</router-link>
                    <router-link :to="{name:'help'}" class="white" :class="active=='5'?'active':''" tag="div">帮助</router-link> -->

          <!-- 机构的个人中心部分 -->
          <!-- <div class="white">
                        欢迎{{ userinfo.org_name}}&nbsp;&nbsp;{{ userinfo.username}}
                    </div> -->

          <el-dropdown class="el_drop" v-show="disable !== true">
            <span class="iconfont"
              >欢迎 {{ userinfo.username
              }}<i class="iconfont icon-yonghu-fuben"></i
            ></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link
                  :to="{ name: 'personal' }"
                  tag="span"
                  class="el_drop_item"
                  >个人空间</router-link
                >
              </el-dropdown-item>
              <el-dropdown-item v-if="is_ip">
                <router-link
                  :to="{
                    name: 'login',
                    query: {
                      showResForm: true,
                    },
                  }"
                  tag="span"
                  class="el_drop_item"
                  >注册账号</router-link
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="logout" class="el_drop_item">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 个人账号退出 -->
          <!-- <div class="white" @click="logout" v-else>退出</div> -->
        </div>
      </div>
    </div>

    <ul class="link_bg" v-if="false">
      <div class="w link_wrap flex">
        <router-link
          :to="{ name: 'index' }"
          class="link_item"
          :class="active == '1' ? 'active' : ''"
          tag="li"
          >文本翻译</router-link
        >
        <router-link
          :to="{ name: 'upload' }"
          class="link_item"
          :class="active == '2' ? 'active' : ''"
          tag="li"
          >文档翻译</router-link
        >
        <router-link
          :to="{ name: 'history' }"
          class="link_item"
          :class="active == '3' ? 'active' : ''"
          tag="li"
          >翻译历史</router-link
        >
        <!-- <li class="link_item">语法校对</li>
                <li class="link_item">智能小觅</li> -->
      </div>
    </ul>
    <!-- 用户退出 -->
    <!-- <el-dropdown class="positions">
            <i class="iconfont icon-yonghu-fuben">{{ userinfo.username }}</i>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <span class="el_drop_item">用户名：{{ userinfo.username }}</span>
                </el-dropdown-item>
                <el-dropdown-item>
                    <span class="el_drop_item">机构名称：{{ userinfo.org_name }}</span>
                </el-dropdown-item>
                <el-dropdown-item>
                    <span @click="logout" class="el_drop_item">退出</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown> -->
  </div>
</template>

<script>
export default {
  props: {
    disable: {
      default: false,
    },
    active: {},
    flag: {
      default: true,
    },
  },
  data() {
    return {
      is_ip: JSON.parse(window.localStorage.getItem("is_ip")),
      userinfo: "",
      path_txt:""
    };
  },
  created() {
    // console.log(this.$route.path);
    this.path_txt = this.$route.path
    this.geiuserinfo();
  },

  methods: {
    geiuserinfo() {
      this.$http.get("home/get_user_info/").then((res) => {
        this.userinfo = res.data.data;
        window.sessionStorage.setItem("username_yi", this.userinfo.username);
      });
    },
    // 退出登录
    logout() {
      window.localStorage.clear();
      this.$router.push({
        name: "login",
      });
    },
  },
};
</script>
<style lang='less' scoped>
.header_wrap {
  background: url("../assets/imgs/header.png") bottom;
  min-width: 1100px;
  position: relative;
}
.positions {
  height: 100px;
  width: 100px;
  color: #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  position: absolute;
  right: 30px;
}
.logo_wrap {
  height: 100px;

  .logo {
    height: 100px;
  }

  .logo_img {
    width: 100px;
  }
  .logo_txt {
    width: 400px;
  }
  h1 {
    margin-left: 0px;

    font-size: 15px;
    font-weight: 400;
    color: #ccc;
    p {
      padding-left: 10px;
    }
  }

  .white {
    position: relative;
    margin: 0 10px;
    padding: 14px 0px;
    font-size: 15px;
    color: #ccc;
    cursor: pointer;

    &.active {
      font-weight: 700;
      color: #fec64d;
    }
    &.active::after {
      content: "";
      display: inline-block;
      position: absolute;
      bottom: 0;
      left: 50%;

      border-radius: 2px;
      width: 40px;
      height: 4px;
      background: rgba(69, 136, 161, 0.9);
      background: #fec64d;
      transform: translate(-50%);
    }
  }
  .about {
    // background: url('../assets/imgs/vip.png')  top no-repeat;
    // background-size: cover;
  }
}
.link_bg {
  background-color: rgba(0, 0, 0, 0.15);
  color: #fff;
  .link_wrap {
    height: 60px;
  }

  .link_item {
    width: 120px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    &.active {
      color: #4588a1;
      font-weight: 700;
    }
  }
}
.logo_l {
  cursor: pointer;
}
.el_drop .iconfont {
  font-size: 15px;
  padding-left: 5px;
  color: #fff;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/ComHeader.vue